import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, ControlContainer, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PaginateData, arrayTarjetones } from 'src/app/models';
import { ExentosService } from 'src/app/services/exentos.service';
import * as moment from 'moment';
import { Formacion } from 'src/app/models/dash';
@Component({
  selector: 'app-exentos-autorizados',
  templateUrl: './exentos-autorizados.component.html',
  styleUrls: ['./exentos-autorizados.component.scss']
})
export class ExentosAutorizadosComponent implements OnInit {
  @ViewChild('myTable') table: any; //DATA TABLE
  dataDocumentos:any[];
  formExeDocumento: FormGroup;
  fileCertificado: File;
  SelectionType = SelectionType;
  rowsDocumentos:any[] = null;
  selected:any[]= [];
  fileCheck:boolean = false;
  @ViewChild('tableDocumentos') tableDocumentos: any; //DATA TABLE DOCUMENTOS
  dataExentos: any[];
  ColumnMode = ColumnMode;
  loadingIndicator : boolean = false; //FIN DATA TABLE
  formBusqueda: FormGroup;
  formExentos: FormGroup;
  formEditVehiculo: FormGroup;
  formEditUser: FormGroup;
  vehiculoEdit:any;
  editarDatosVehiculo:boolean = false;
  rowEdit:number;
  arrayTempTarjetones:arrayTarjetones[] = [];
  registroVehiculo:boolean = false;
  openTab=1;
  exentos:any;
  descuentos:any[] = [];
  vehiculosForm:FormGroup;
  modalUploadDocExe:boolean = false;
  idsVehiculos:any[] = [];
  id_persona = "";
  allExentos:any; //buffer de todos los excentos
  Exentos:any;
  modalEdit=false;  //BANDERA PARA MODAL DE VEHICULO
  modalEditUser=false;  //BANDERA PARA MODAL DE USUARIO
  modalShowHistorial=false; //BANDERA PARA MODAL DE HISTORIAL
  /***Variables Historial */
  @ViewChild('tablaHistorial') tablaHistorial: any;
  historialList: any[];
  filasHistorial = [];
  listaPersonas =[];
  exeAcciones = [{id:1, nombre_accion: "CREACION"},{id:2, nombre_accion: "VEHICULO/PLAZAS"},{id:3, nombre_accion: "PROPIETARIO"}];
  historialExpanded: any = {};
  columnasHistorial: any[] = [
    { name: 'Día/Hora', prop: 'diaHora', sortable: true },
    { name: 'Operación', prop: 'operacion', sortable: true }
  ];
  estatus = {
   1: "ACTIVO",
   2: "INACTIVO",
   3: "SUSPENDIDO"
  }
  tipoPases:any[] = [];
  tipoPasesGeneral:any[]=[];
  arrayTarjetones:any[] = [];
  nombrePlaceHolder = 'PATERNO MATERNO NOMBRE(S)';
  /*********/

  arrayPlazas:any[] = [];

  /****** */

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private ngxUiLoaderService:NgxUiLoaderService,
    private exentosService:ExentosService) { }

  ngOnInit(): void {
    this.ngxUiLoaderService.start();
    this.createFormBusqueda();
    this.createForm();
    this.vehiculosForm = this.createFormVehiculo(); // Inicializa vehiculosForm aquí
    this.vehiculosForm.get('fecha_registro').setValue(moment().format('YYYY-MM-DD'));//fecha actual
    /** */
    //this.testFunction(); //funcion para rellenar
    /** */
    this.arrayPlazas = ['Brisas','Pisal','Caimanero','Alhuey','SanBlas','PSM']; //debe ser reemplazado por una llamada a las plazas
    /** */
    this.vehiculosForm
    this.getTiposPase();
    this.getExentos();
    //FORMULARIO DE EDICION
    this.formEditVehiculo = this.createFormEditTarjeton();
    //this.formEditVehiculo.get('fecha_registro').setValue(moment().format('YYYY-MM-DD'));//fecha actual
    //AGREGANDO LAS PLAZAS A vehiculosForm Y formEditVehiculo
    this.addPlazas(this.arrayPlazas);
    this.addPlazasEdit(this.arrayPlazas);
    //FORMULARIO EDICION DE USUARIO
    this.formEditUser = this.formBuilder.group({
      id : ['',Validators.required],
      nombre:['', Validators.required]
    });
    this.ngxUiLoaderService.stop();
  }

  createFormBusqueda() {
    this.formBusqueda = this.formBuilder.group({
      tipo_pase: [''],
      no_tarjeton: ['']
    });

    //FORMULARIO DE DOCUMENTOS
    this.formExeDocumento = this.formBuilder.group({
      id : [''],
      placas: [''],
      tarjeton: [''],
      tipo_pase: [''],
      check_file:[false],
      id_documento:[''],
      file: ['']
    });
  }

  createForm() {
    this.formExentos = this.formBuilder.group({
      nombre: ['', Validators.required],
      vehiculos: this.formBuilder.array([]),
    },{
      validators: [this.validateNameOnlyText()]
    });
  }

  createFormVehiculo(){
    return this.formBuilder.group({
      tarjeton: [{value: '', disabled:true }, Validators.required],
      fecha_registro: ['', Validators.required],
      fecha_valido: ['', Validators.required],
      modelo: ['', Validators.required],
      no_economico: ['', Validators.required],
      anio: ['', Validators.required],
      tipo_pase: ['', Validators.required],
      estatus: ['1', Validators.required],
      marca: ['', Validators.required],
      tipo: ['', Validators.required],
      placa: ['', Validators.required],
      descuento: ['', Validators.required],
      linea: [''],
      dependencia: [''],
      poblado: [''],
      plazas: this.formBuilder.array([],Validators.required),
      observaciones:['']
    },{
      validators: [this.limitDescuento(),this.validateAnioAuto(),this.validateFechaFinTarjeton(),this.almenosUno()]
    });
  }

   //VALICIONES DE FORMULARIO
   validateNameOnlyText(){
    return (formGroup:AbstractControl): ValidationErrors | null => {
      const name = formGroup.get('nombre')?.value;
      if (/\d/.test(name)) { //CONTIENE ALGUN NUMERO
        formGroup.get('nombre')?.setErrors({ onlyLetters: true})
        this.toastr.error('El nombre no debe contener números', '', { positionClass: 'toast-bottom-right' });
        formGroup.get('nombre').setValue(name.toString().slice(0, -1));
        console.log("validateNameOnlyText");
        return { onlyLetters:true }
      }
      formGroup.get('nombre')?.setErrors(null);
      return null;
    }
  }


  validateFechaFinTarjeton(){
    return (formGroup:AbstractControl): ValidationErrors | null => {
      const fecha_registro = moment(formGroup.get('fecha_registro')?.value , 'YYYY-MM-DD');
      const fecha_valido = moment(formGroup.get('fecha_valido')?.value, 'YYYY-MM-DD');
      if (fecha_valido.isBefore(fecha_registro)) { //CONTIENE ALGUN NUMERO
        formGroup.get('fecha_valido')?.setErrors({ dateLimit: true});
        formGroup.get('fecha_registro')?.setErrors({ dateLimit: true});
        this.toastr.error('La fecha limite no debe ser menor a la fecha de registro', '', { positionClass: 'toast-bottom-right' })
        formGroup.get('fecha_valido').reset();
        return { dateLimit:true }
      }
      formGroup.get('fecha_valido')?.setErrors(null);
      return null;
    }
  }

  limitDescuento() {
    return (formGroup:AbstractControl): ValidationErrors | null => {
      const descuento = formGroup.get('descuento')?.value;
      if (descuento > 100) { //CONTIENE ALGUN NUMERO
        formGroup.get('descuento')?.setErrors({ maxNumber:true})
        formGroup.get('descuento').setValue(descuento.slice(0, -1));
        this.toastr.error('La cantidad del descuento supera el máximo del porcentaje permitido', '', { positionClass: 'toast-bottom-right' })
        return { maxNumber:true }
      }
      formGroup.get('descuento')?.setErrors(null);
      return null;
    }
  }

  validateAnioAuto() {
    return (formGroup:AbstractControl): ValidationErrors | null => {
      const anio = formGroup.get('anio')?.value;
      const anioMax =  moment().year();
      if (anio > anioMax + 1) { //AÑO DE VEHICULO
        formGroup.get('anio')?.setErrors({ maxAnio:true})
        formGroup.get('anio').setValue(anio.toString().slice(0, -1));
        this.toastr.error('El año del vehiculo es invalido', '', { positionClass: 'toast-bottom-right' })
        return { maxAnio:true }
      }
      formGroup.get('anio')?.setErrors(null);
      return null;
    }
  }

  /* Funciones para agregar plazas y probar */

  testFunction(){
    this.vehiculosForm.get('modelo').setValue('MODELO');
    this.vehiculosForm.get('marca').setValue('MARCA');
    this.vehiculosForm.get('no_economico').setValue(1234);
    this.vehiculosForm.get('anio').setValue(2023);
    this.vehiculosForm.get('tipo').setValue('TIPO');
    this.vehiculosForm.get('placa').setValue('PLACA');
    this.vehiculosForm.get('fecha_valido').setValue(moment().format('YYYY-MM-DD'));//fecha actual
    this.vehiculosForm.get('linea').setValue('LINEA');
    this.vehiculosForm.get('dependencia').setValue('DEPENDENCIA');
    this.vehiculosForm.get('poblado').setValue('POBLADO');
    this.vehiculosForm.get('observaciones').setValue('OBSERVACIONES');
  }

  addPlazas(plazasVector){
    plazasVector.forEach(plaza => {
      const checkboxControl =this.formBuilder.control(false);
      (this.vehiculosForm.get('plazas') as FormArray).push(checkboxControl);
    });
  }

  addPlazasEdit(plazasVector){
    plazasVector.forEach(plaza => {
      const checkboxControlEdit = this.formBuilder.control(false);
      (this.formEditVehiculo.get('plazas') as FormArray).push(checkboxControlEdit);
    });
  }

  almenosUno(){
    return (formGroup:AbstractControl): ValidationErrors | null => {
      let valores = formGroup.get('plazas').value;
      if(valores.length > 0){
        let unoAlmenos = valores.some(valor => valor == true );
        if(!unoAlmenos && this.modalEdit){
          this.toastr.error('Seleccione una o mas plazas', '', { positionClass: 'toast-bottom-right' })
        }
        return unoAlmenos ? null :{ unoAlmenos: true};
      }
      return {error: true};
    }
  }
  /*Funciones Generales */

  get vehiculos() {
    return this.formExentos.controls["vehiculos"] as FormArray;
  }



  async buscarVehiculos() {
    try {
      // console.log("Inicia busqueda");
      this.ngxUiLoaderService.start();
      this.exentosService.busquedaPersonalizada(this.formBusqueda.value).then( Data =>{
        this.exentos = Data;
      });
      this.formBusqueda.reset();
      this.formBusqueda.get("tipo_pase").setValue("");
      this.ngxUiLoaderService.stop();

    } catch (error) {
      this.toastr.error('Error al obtener los registros', 'favor de intentar de nuevo', { positionClass: 'toast-bottom-right' });
    }
  }

  // async buscarVehiculos() {

  //   if (this.formBusqueda.get('no_tarjeton') != null && !isNaN(this.formBusqueda.get('no_tarjeton').value) ) {
  //     // console.log(this.formBusqueda.get('no_tarjeton').value);
  //     // console.log(this.formBusqueda.get('tipo_pase').value);
  //     // console.log(this.allExentos[0].no_tarjeton);
  //     let numeroTarjeton = this.formBusqueda.get('no_tarjeton').value;

  //     this.exentos = this.allExentos.filter(exento => parseInt(exento.no_tarjeton) == numeroTarjeton);
  //     // console.log(this.exentos);
  //   }else{
  //     this.exentos = this.allExentos;

  //   }
  // }

  async getExentos() {
    this.loadingIndicator = true;
    try {
      this.exentosService.getExentos().subscribe((vehiculos)=>{
        this.allExentos = vehiculos;
        this.actualizarTablaTarjetones();
        this.loadingIndicator = false;
       });
    } catch (error) {
        this.toastr.error('Error al obtener los registros', 'favor de intentar de nuevo', { positionClass: 'toast-bottom-right' });
        this.loadingIndicator = false;
    }
  }

  async getTiposPase() {
    try {
      this.ngxUiLoaderService.start();
      //this.tipoPases = await this.exentosService.getTiposPase();
      this.tipoPasesGeneral = await this.exentosService.getTiposPase();
      this.getDescuentos();
      this.ngxUiLoaderService.stop();
    } catch (error) {
      this.ngxUiLoaderService.stop();
      this.toastr.error(`No se pudierón obtener los tipos de pases, ${error}`, 'Favor de intentar de nuevo.', { positionClass: 'toast-bottom-right' })
    }
  }

  async getDescuentos() {
    let descuentos = await this.exentosService.getDescuentos();
    this.descuentos = descuentos.data.sort((a, b) => a.descuento - b.descuento);
  }

  addVehiculo() {
    /*
    let selectedPlazas = this.vehiculosForm.get('plazas').value;
    let alMenosUno = selectedPlazas.some(valor => valor === true);
    //alMenosUno
    if(this.almenosUno){

    }else{}
    */
    const valoresActuales = this.vehiculosForm.getRawValue(); // Valores actuales del formulario
    valoresActuales.plazas = [valoresActuales.plazas];//no deja guardarlo sin que exista dentro de un array
    //(valoresActuales);
    const nuevoFormGroup = this.formBuilder.group(valoresActuales);// Clonamos el FormGroup con los valores actuales
    this.vehiculos.push(nuevoFormGroup);// Agrega el nuevo FormGroup al FormArray
    this.addTarjetones();
    this.limpiarFormVehiculo();
  }

  addTarjetones() {
    let tipo_pase = this.vehiculosForm.get('tipo_pase')?.value;
    if (this.arrayTempTarjetones.length > 0) {
      let busquedaByTipoPase = this.arrayTempTarjetones.find(item => item.tipo_pase === tipo_pase);
      if (busquedaByTipoPase) {
        const tarjetones = busquedaByTipoPase.tarjetones;
        tarjetones.push(this.vehiculosForm.get('tarjeton')?.value);
      } else {
        this.arrayTempTarjetones.push({
          tipo_pase: tipo_pase,
          tarjetones: [this.vehiculosForm.get('tarjeton')?.value]
        });
      }
    }else {
      this.arrayTempTarjetones.push({
        tipo_pase: tipo_pase,
        tarjetones: [this.vehiculosForm.get('tarjeton')?.value]
      });
    }
  }


  createFormEditTarjeton() {
    return this.formBuilder.group({
      id: ['', Validators.required],
      persona: ['', Validators.required],
      tarjeton: [{value: '', disabled:true }, Validators.required],
      fecha_registro: ['', Validators.required],
      fecha_valido: ['', Validators.required],
      modelo: ['', Validators.required],
      no_economico: ['', Validators.required],
      anio: ['', Validators.required],
      tipo_pase: ['', Validators.required],
      estatus: ['1', Validators.required],
      marca: ['', Validators.required],
      tipo: ['', Validators.required],
      placa: ['', Validators.required],
      descuento: ['', Validators.required],
      linea: [''],
      dependencia: [''],
      poblado: [''],
      plazas: this.formBuilder.array([],Validators.required),
      observaciones:['']
    },{
      validators: [this.limitDescuento(),this.validateAnioAuto(),this.validateFechaFinTarjeton(),this.almenosUno()]
    });
  }

  setOpenTab(val){
    this.openTab=val;
  }
  async openModalEdit(row){ //EDITAR DATOS DE PERSONA Y VEHICULO EN BD
    console.log(row);
    let vehiculo = await this.exentosService.showVehiculo(Number(row));
    this.vehiculoEdit = vehiculo;
    console.log(vehiculo);
    //setting tipos pases
    this.getTarjetonEdit(vehiculo.id_tipo_pase);

    this.formEditVehiculo.get('id').setValue(vehiculo.id);
    this.formEditVehiculo.get('persona').setValue(vehiculo.persona.nombre);
    this.formEditVehiculo.get('tarjeton').setValue(vehiculo.no_tarjeton);
    this.formEditVehiculo.get('modelo').setValue(vehiculo.modelo);
    this.formEditVehiculo.get('marca').setValue(vehiculo.marca);
    this.formEditVehiculo.get('no_economico').setValue(vehiculo.no_economico);
    this.formEditVehiculo.get('tipo_pase').setValue(vehiculo.id_tipo_pase);
    this.formEditVehiculo.get('estatus').setValue(vehiculo.estatus);
    this.formEditVehiculo.get('anio').setValue(vehiculo.anio);
    this.formEditVehiculo.get('tipo').setValue(vehiculo.tipo == null ? '' : vehiculo.tipo);
    this.formEditVehiculo.get('placa').setValue(vehiculo.placa);
    this.formEditVehiculo.get('descuento').setValue(vehiculo.descuento.id);
    this.formEditVehiculo.get('fecha_registro').setValue(moment(vehiculo.fecha_registro).format('YYYY-MM-DD'));
    this.formEditVehiculo.get('fecha_valido').setValue(moment(vehiculo.fecha_valido).format('YYYY-MM-DD'));
    this.formEditVehiculo.get('linea').setValue(vehiculo.linea);
    this.formEditVehiculo.get('dependencia').setValue(vehiculo.dependencia);
    this.formEditVehiculo.get('poblado').setValue(vehiculo.poblado);
    this.formEditVehiculo.get('observaciones').setValue(vehiculo.observaciones);

    this.modalEdit=true;
    //cambiar el los numeros por array de boleanos
    let valores = vehiculo.plazas;
    //let valores = [1,2,3,4,5,6];

    const plazasEditArray = this.formEditVehiculo.get('plazas') as FormArray;
    // this.arrayPlazas.forEach((plaza)=>{
    //   let controlador = plazasEditArray.at(plaza-1);
    //   controlador.setValue(valores[plaza]);
    //})
    for (let i=0; i < valores.length; i++){
      let controlador = plazasEditArray.at(valores[i]-1);
      controlador.setValue(1);
    }
    // for (let i = 0; i < this.arrayPlazas.length; i++) {
    //   let controlador = plazasEditArray.at(valores[i]-1);
    //   console.log(valores[i], i)
    //   controlador.setValue(valores[i]);
    //}



  }

  async openModalEditUser(nombre, id){ //EDITAR DATOS DE PERSONA Y VEHICULO EN BD
    this.modalEdit=false;
    this.formEditUser.get('nombre').setValue(nombre);
    this.formEditUser.get('id').setValue(id);
    this.modalEditUser = true;
  }

  closeModalEdit(){
    this.formEditVehiculo.reset();
    this.modalEdit=false;
  }

  async dismissModalUser(guardar){
    if(!guardar) { //cerrar el modal
      return this.modalEditUser = false;
    }
    try { //usar el ciclo de
      this.ngxUiLoaderService.start('savePersona');
      await this.exentosService.updatePersonaExento(this.formEditUser.value);
      //await this.getExentos();cambiar
      this.ngxUiLoaderService.stop('savePersona');
      this.toastr.success('El registro a sido actualizado con éxito!','', { positionClass: 'toast-bottom-right' });
      this.getExentos();
      this.modalEditUser = false;
    } catch (error) {
      this.ngxUiLoaderService.stop('savePersona');
      this.toastr.error('Lo sentimos algo salio mal, intenta de nuevo','', { positionClass: 'toast-bottom-right' });
    }
  }

  changeIndex(){
    //cargar el id del vehiculo
    console.log('this vehicuoloEdit');
    console.log({... this.vehiculoEdit});

    //verificar que le nombre sea correcto o nuevo (call savePersona)
    this.ngxUiLoaderService.start();
    let id_nuevo_propietario;
    let id = this.vehiculoEdit.id;
    console.log('this.formEditUser');
    console.log(this.formEditUser.value);
    this.exentosService.savePersonaExento(this.formEditUser.value)
    .then((usuario) => {
      console.log('usuario');
      console.log(usuario);
      id_nuevo_propietario = usuario.id;
      let data = {id,id_nuevo_propietario};
      console.log(data);
      this.exentosService.modificarPropietario(data).then((retorno)=>{
        console.log("index");
        console.log('index');
        this.toastr.success('Cambio creado con éxito', '', { positionClass: 'toast-bottom-right' });
        this.ngxUiLoaderService.stop();
        this.getExentos(); // actualizar la tabla
        this.modalEditUser = false;
      }).catch(err=>{
        this.ngxUiLoaderService.stop()
        this.toastr.error('Ocurrio Un Error','Cambio no Exitoso', { positionClass: 'toast-bottom-right' })
        this.modalEditUser = true;
      })
    }).catch(err => {
        this.ngxUiLoaderService.stop()
        this.toastr.error('Ocurrio Un Error', 'Favor de registrar otro usuario', { positionClass: 'toast-bottom-right' })
        this.modalEditUser = true;
    });


    //resignar el vehiculo a la this.formEditVehiculo.value

    console.log({...this.formEditVehiculo.value})
  }

  savePersona(nuevo?) {

    let nombreExento = this.formExentos.get('nombre').value;
    let nombreExentoTrimmed = nombreExento.trim();
    if ( nombreExentoTrimmed == null || nombreExentoTrimmed == '') {
      this.toastr.error('Campo Nombre Vacio', 'Favor de registrar usuario', { positionClass: 'toast-bottom-right' });
      return 0;
    }
    this.ngxUiLoaderService.start();
    this.exentosService.savePersonaExento(this.formExentos.value)
    .then((usuario) => {
         this.id_persona = usuario.id;
         this.ngxUiLoaderService.stop()
         this.toastr.success('Usuario creado con éxito', '', { positionClass: 'toast-bottom-right' })
         this.registroVehiculo = true;
      }).catch(err => {
        this.ngxUiLoaderService.stop()
        this.toastr.error('Usuario existente', 'Favor de registrar otro usuario', { positionClass: 'toast-bottom-right' })
        this.registroVehiculo = false;
      });

      if(nuevo){
        this.tipoPases = this.tipoPasesGeneral.filter((tipoPase)=> tipoPase);
        console.log(this.tipoPases);
      }
  }


   eliminarRow(row:number, vehiculo) {
    this.rowEdit = row;
    this.modificarArrayTemp(true);
    this.filtraYModificarConsecutivo();
    this.vehiculos.removeAt(row);
    this.rowEdit = null;
   }

   toggleExpandGroup(group) {
    this.table.groupHeader.toggleExpandGroup(group);
  }

  async saveVehiculosPersona() {
    try {
      this.ngxUiLoaderService.start();
      let vehiculos = await this.exentosService.saveVehiculoPersona({...this.formExentos.value, persona: this.id_persona});
      this.idsVehiculos = vehiculos.data;
      //await this.getExentos();//cambiar
      this.toastr.success(`${vehiculos.message}`, '', { positionClass: 'toast-bottom-right' });
      await this.downloadTarjetonesPDF();
      this.getExentos();
      this.ngxUiLoaderService.stop();
    } catch (error) {
      this.ngxUiLoaderService.stop();
      this.toastr.error('Error al realizar el registro', 'Favor de intentar de nuevo', { positionClass: 'toast-button-right' });

    }
  }

  async downloadTarjetonesPDF() {
    try {
     this.ngxUiLoaderService.start('tarjeton');
     let file = await this.exentosService.downloadTarjetones(this.idsVehiculos);
     //this.idsVehiculos = []; //limpiamos la variable pues de no hacerlo a la siguiente carga solo aparece "descargar pdf"
     let urlFile = this.exentosService.downloadFileTarjetones(file, `tarjetones__${moment().format('YYYY-MM-DD')}.pdf`);
     if(urlFile != ''){
       this.ngxUiLoaderService.stop('tarjeton');
       this.registroVehiculo = false;
       this.formExentos.reset();
       this.vehiculos.clear();
       return this.toastr.success('Se ha descargado con éxito el archivo', '', { positionClass: 'toast-bottom-right' });
     }else{
       this.ngxUiLoaderService.stop('tarjeton');
       return this.toastr.error('Error al descargar favor de intentar de nuevo', '', { positionClass: 'toast-bottom-right' });
     }
    } catch (error) {
      this.ngxUiLoaderService.stop('tarjeton');
      return this.toastr.error('Error al descargar favor de intentar de nuevo', '', { positionClass: 'toast-bottom-right' });
    }
  }

  editarRow(row:number) {
    this.editarDatosVehiculo = true;
    let vehiculo = this.vehiculos.at(row); //GET
    this.rowEdit = row;
    this.vehiculosForm.get('tarjeton').setValue(vehiculo.get('tarjeton').value);
    this.vehiculosForm.get('modelo').setValue(vehiculo.get('modelo').value);
    this.vehiculosForm.get('marca').setValue(vehiculo.get('marca').value);
    this.vehiculosForm.get('no_economico').setValue(vehiculo.get('no_economico').value);
    this.vehiculosForm.get('tipo_pase').setValue(vehiculo.get('tipo_pase').value);
    this.vehiculosForm.get('estatus').setValue(vehiculo.get('estatus').value);
    this.vehiculosForm.get('anio').setValue(vehiculo.get('anio').value);
    this.vehiculosForm.get('tipo').setValue(vehiculo.get('tipo').value);
    this.vehiculosForm.get('placa').setValue(vehiculo.get('placa').value);
    this.vehiculosForm.get('descuento').setValue(vehiculo.get('descuento').value);
    this.vehiculosForm.get('fecha_registro').setValue(vehiculo.get('fecha_registro').value);
    this.vehiculosForm.get('fecha_valido').setValue(vehiculo.get('fecha_valido').value);
    this.vehiculosForm.get('linea').setValue(vehiculo.get('linea').value);
    this.vehiculosForm.get('dependencia').setValue(vehiculo.get('dependencia').value);
    this.vehiculosForm.get('poblado').setValue(vehiculo.get('poblado').value);
    this.vehiculosForm.get('observaciones').setValue(vehiculo.get('observaciones').value);
    let valores = vehiculo.get('plazas').value;
    //Set de los checkboxes con false o true segun dependa
    const plazasFormArray = this.vehiculosForm.get('plazas') as FormArray;
    for (let i = 0; i < this.arrayPlazas.length; i++) {
      const control = plazasFormArray.at(i);
      control.setValue(valores[i]);
    }
  }

  async getFolioTarjeton() {
    if (this.arrayTempTarjetones.length > 0) {
      let busquedaByTipoPase = this.arrayTempTarjetones.find(item => item.tipo_pase === this.vehiculosForm.get('tipo_pase')?.value);
      if (!busquedaByTipoPase) {
         return await this.createNoTarjeton(1);
      }
      this.createTarjetonConsecutivo(this.vehiculosForm.get('tipo_pase')?.value);
    }else{
       await this.createNoTarjeton(1);
    }
  }

  async createNoTarjeton(tipoForm) {
    let formulario = tipoForm == 1 ? this.vehiculosForm : this.formEditVehiculo;
    try {
        this.ngxUiLoaderService.start();
        const tarjeton =  await this.exentosService.getFolioTarjeton(formulario.get('tipo_pase')?.value);
        formulario.get('tarjeton').setValue(tarjeton);
        this.ngxUiLoaderService.stop();
        this.toastr.success('El número del tarjetón ha sido creado con éxito !','Tarjetón creado',{ positionClass: 'toast-bottom-right' });
        return tarjeton;
    } catch (error) {
      this.ngxUiLoaderService.stop();
      this.toastr.error(`No se pudo obtener el tarjetón, ${error}`, 'Favor de intentar de nuevo.', { positionClass: 'toast-bottom-right' })
    }
  }

  async getTarjetonEdit(tipoPase?) {
    console.log(tipoPase);
    switch (tipoPase) {
      case 61:
        this.tipoPases = this.tipoPasesGeneral.filter((pase)=>(pase.id == 61 || pase.id == 62));
        break;
      case 62:
        this.tipoPases = this.tipoPasesGeneral.filter((pase)=>(pase.id == 61 || pase.id == 62));
        break;
      case 76:
        this.tipoPases = this.tipoPasesGeneral.filter((pase)=>pase.id == 76);
        break;
      case 77:
        this.tipoPases = this.tipoPasesGeneral.filter((pase)=>pase.id == 77);
        break;
      default:
        this.tipoPases = this.tipoPasesGeneral.filter((pase)=> pase)
        break;
    }

    console.log(this.tipoPases);
  }

  createTarjetonConsecutivo(tipo_pase) {
    let busquedaByTipoPase = this.arrayTempTarjetones.find(item => item.tipo_pase === tipo_pase);
    const tarjetones = busquedaByTipoPase.tarjetones;
    let noTarjeton = this.getNumberTarjeton(tarjetones);
    this.vehiculosForm.get('tarjeton').setValue(noTarjeton);
  }

  getNumberTarjeton(tarjetones) {
    let ultimaPosicion = tarjetones.length - 1;
    const consecutivo =  parseInt(tarjetones[ultimaPosicion],10) + 1;
    let newTarjeton = consecutivo.toString().padStart(3, '0');
    return newTarjeton;
  }

  modificarEdit() {
    if (this.vehiculos.at(this.rowEdit).get('tipo_pase')?.value != this.vehiculosForm.get('tipo_pase')?.value) {
      this.modificarArrayTemp(false);
    }
    this.editarDatosVehiculo = false;
    this.vehiculos.removeAt(this.rowEdit);
    const valoresActuales = this.vehiculosForm.getRawValue(); // Valores actuales del formulario
    valoresActuales.plazas = [valoresActuales.plazas]; //no lo cambies si no no jala
    const nuevoFormGroup = this.formBuilder.group(valoresActuales);// Clonamos el FormGroup con los valores actuales
    this.vehiculos.insert(this.rowEdit,nuevoFormGroup);// Agrega el nuevo FormGroup al FormArray
    this.limpiarFormVehiculo();
    this.rowEdit = null;
    this.toastr.success('Los datos del vehiculo se han sido modificados con éxito !','',{ positionClass: 'toast-bottom-right' });
  }

  modificarArrayTemp(eliminar) {
    let tipoPase = this.arrayTempTarjetones.find(tipoPase => tipoPase.tipo_pase == this.vehiculos.at(this.rowEdit).get('tipo_pase')?.value);
    if (tipoPase) {
      if (!eliminar) {
        this.modificarArrayFormVehiculos();
        this.addTarjetones();
      }
      const indiceTarjeton = tipoPase.tarjetones.indexOf(this.vehiculos.at(this.rowEdit).get('tarjeton').value);//NUM ANTERIOR
      for (let i = indiceTarjeton; i <  tipoPase.tarjetones.length; i++) {
        let consecutivo =  parseInt(tipoPase.tarjetones[i] , 10) - 1;
        tipoPase.tarjetones[i] = consecutivo.toString().padStart(3, '0');
      }
      tipoPase.tarjetones.splice(indiceTarjeton, 1);
      if (tipoPase.tarjetones.length == 0) {
        const indice = this.arrayTempTarjetones.findIndex(tipoPases => tipoPases.tipo_pase == this.vehiculos.at(this.rowEdit).get('tipo_pase')?.value);
        this.arrayTempTarjetones.splice(indice,  1);
      }
    }
  }

  modificarArrayFormVehiculos() {
    let nuevoTipoPase = this.vehiculosForm.get('tipo_pase')?.value;
    let anteriorTipoPase = this.vehiculos.at(this.rowEdit).get('tipo_pase')?.value;
    const existeTipoAnterior = this.vehiculos.controls.some((control: FormGroup) => control.get('tipo_pase').value == anteriorTipoPase);
    if (existeTipoAnterior) {
      this.filtraYModificarConsecutivo();
    }
    const existeTipoPase = this.vehiculos.controls.some((control: FormGroup) => control.get('tipo_pase').value == nuevoTipoPase);
     if (existeTipoPase) {
      const newTarjeton =  this.filtraYBuscaTarjetonMayor().toString().padStart(3, '0');
      this.vehiculos.at(this.rowEdit).get('tipo_pase').setValue(newTarjeton);
    }

  }

  filtraYBuscaTarjetonMayor() {
    const formByTipo = this.vehiculos.controls.filter(control => {
      return control.get('tipo_pase').value === this.vehiculosForm.get('tipo_pase')?.value;
    });
    if (formByTipo.length > 0) {
      const tarjetones = formByTipo.map(control => parseInt(control.get('tarjeton').value,10));
      return  Math.max(...tarjetones);
    }else{
      return 1;
    }
  }

  filtraYModificarConsecutivo() {
    let tarjetonAnterior = this.vehiculos.at(this.rowEdit).get('tarjeton').value;
    for (let i = 0; i < this.vehiculos.controls.length; i++) {
      const control = this.vehiculos.at(i) as FormGroup;
      const tarjeton = control.get('tarjeton').value;

      if (control.get('tipo_pase').value == this.vehiculos.at(this.rowEdit).get('tipo_pase').value && i != this.rowEdit) {
        if (parseInt(control.get('tarjeton').value,10) > parseInt(tarjetonAnterior)) {
          tarjetonAnterior = parseInt(control.get('tarjeton').value,10);
           // Restar 1 al número de tarjeton
          const nuevoTarjeton = (parseInt(tarjeton, 10) - 1).toString().padStart(3, '0');;
          control.get('tarjeton').setValue(nuevoTarjeton);
        }
      }
    }
  }

  cancelarEdit(){
    this.editarDatosVehiculo = false;
    this.limpiarFormVehiculo();
  }

  limpiarFormVehiculo() {
    this.vehiculosForm.reset();
    this.vehiculosForm.get('fecha_registro').setValue(moment().format('YYYY-MM-DD'));//fecha actual
  }

  async downloadTarjetonVehiculo(vehiculo) {
    console.log(vehiculo);
    this.ngxUiLoaderService.start('tarjeton');
    try {
      let file = await this.exentosService.downloadTarjetones([vehiculo.id]);
      let urlFile = this.exentosService.downloadFileTarjetones(file, `tarjetones__${moment().format('YYYY-MM-DD')}.pdf`);
      if(urlFile != ''){
        this.ngxUiLoaderService.stop('tarjeton');
        return this.toastr.success('Se ha descargado con éxito el archivo', '', { positionClass: 'toast-bottom-right' });
      }else{
        this.ngxUiLoaderService.stop('tarjeton');
        return this.toastr.success('Se ha descargado con éxito el archivo', '', { positionClass: 'toast-bottom-right' });
      }
    } catch (error) {
      console.log(error);
      this.ngxUiLoaderService.stop('tarjeton');
      return this.toastr.success('Se ha descargado con éxito el archivo', '', { positionClass: 'toast-bottom-right' });
    }


  }

  async modificarVehiculo() {
    try {
      this.ngxUiLoaderService.start('update');
      let vehiculoEditable = this.allExentos.filter(exento => exento.id == this.vehiculoEdit.id);
      console.log(vehiculoEditable);
      await this.exentosService.modificarVehiculo(
        this.vehiculoEdit.id,
        {...this.formEditVehiculo.value,
          tarjeton: this.formEditVehiculo.get('tarjeton').value})
          .then(result =>{
            console.log(this.allExentos[this.vehiculoEdit.id]);
            this.EditarItemAllExentos(this.vehiculoEdit.id);
          });
      //this.getExentos();
      this.ngxUiLoaderService.stop('update');
      this.modalEdit = false;
      return this.toastr.success('Los datos del vehiculo han sido modificiados.','',{ positionClass: 'toast-bottom-right' });
    } catch (error) {
      this.ngxUiLoaderService.stop('update');

      return this.toastr.error('Lo sentimos algo salio mal intenta de nuevo','Error al modificar', { positionClass: 'toast-bottom-right' });
    }
  }

  /* Edita los valores de un vehiculo desde "formEditVehiculo" despues
   * de una llamada exitosa a exentosService.ModificarVehiculo
   */
  EditarItemAllExentos(id){
    let item = this.allExentos.find(exento => exento.id == id)
    if (item){
      item.tarjeton         = this.formEditVehiculo.get('tarjeton').value;
      item.modelo           = this.formEditVehiculo.get('modelo').value;
      item.marca            = this.formEditVehiculo.get('marca').value;
      item.no_economico     = this.formEditVehiculo.get('no_economico').value;
      item.tipo_pase        = this.formEditVehiculo.get('tipo_pase').value;
      item.estatus          = this.formEditVehiculo.get('estatus').value;
      item.anio             = this.formEditVehiculo.get('anio').value;
      item.tipo             = this.formEditVehiculo.get('tipo').value;
      item.placa            = this.formEditVehiculo.get('placa').value;
      item.descuento        = this.formEditVehiculo.get('descuento').value;
      item.fecha_registro   = this.formEditVehiculo.get('fecha_registro').value;
      item.fecha_valido     = this.formEditVehiculo.get('fecha_valido').value;
      item.linea            = this.formEditVehiculo.get('linea').value;
      item.dependencia      = this.formEditVehiculo.get('dependencia').value;
      item.poblado          = this.formEditVehiculo.get('poblado').value;
      item.observaciones    = this.formEditVehiculo.get('observaciones').value;

      //adquiriendo las plazas
      let arreglo = [];
      let counter = 1;
      const plazasArray = this.formEditVehiculo.get('plazas') as FormArray;
      const values = plazasArray.controls.map(control => control.value);
      values.forEach(element => {
        if (element) {
          arreglo.push(counter.toString());
        }
        counter++;
      });
      item.plazas = arreglo;
      this.actualizarTablaTarjetones();
    }
  }

  /**
   *  Fuerza la actualizacion de la tabla con todos los exentos existentes
   *  SOLO USAR despues de una excucion exitosa de algun servicio Update
   */
  actualizarTablaTarjetones(){
    this.exentos = [...this.allExentos];
  }

  closeModalDocExe(){

  }

  async mostrarHistorialExcento(row){
    await this.exentosService.getPersonaAll().then(data =>
      {
        this.listaPersonas = data;
      }
    )
    await this.exentosService.getHistorialById(Number(row)).then(data => {
      this.historialList = data;
      this.mapHistorial();
     });
     this.modalShowHistorial = true;
  }

  mapHistorial(){
    this.filasHistorial = this.historialList.map(item =>{
      const detalles = JSON.parse(item.cambio);
      if(detalles.id_persona){
        detalles.Propietario = this.getNombrePersona(detalles.id_persona);
          delete detalles.id_persona;
      }
      if (detalles.plazas) {
          const indices = detalles.plazas.split(',').map(s => parseInt(s.trim()));
          const nombres = indices.map(index => this.arrayPlazas[index - 1]).filter(name => name);

          detalles.pase = nombres.join(', ');
          delete detalles.plazas;
      }
      return {
        diaHora: this.formatearFecha(item.created_at),
        operacion: `CAMBIO: ${this.getAccion(item.id_exe_accion)}`,
        detallesCambio: detalles
      };
    })
    console.log(this.filasHistorial);
  }

  getNombrePersona(id_persona){
    const nombre_persona = this.listaPersonas.find(p => p.id === id_persona);
    return nombre_persona ? nombre_persona.nombre : `${id_persona} (Nombre no encontrado)`;
  }

  getAccion(id_accion){
    const accion = this.exeAcciones.find(x => x.id === id_accion);
    return accion ? accion.nombre_accion : `(Operacion no encontrada)`;
  }

  formatearFecha(fechaUTC: string): string {
    return new Date(fechaUTC).toLocaleString('es-MX');
  }

  otherToggleExpandRow(row): void {
  this.tablaHistorial[row.$$index] = !this.tablaHistorial[row.$$index];
  this.filasHistorial = [...this.filasHistorial];
  }

  toggleExpandRow(row): void {
    if (this.tablaHistorial){
      console.log("tabla historial existe");
      if(this.tablaHistorial.rowDetail) {
        console.log("toggleExpand existe");
        this.tablaHistorial.rowDetail.toggleExpandRow(row);
      }
  } else {
    console.error("Referencia a tablaHistorial no disponible. ¿Está el modal abierto?");
  }
  }
  closeModalHistorial(){
    this.modalShowHistorial = false;
    this.filasHistorial = [];
    this.listaPersonas = [];
    this.historialExpanded = {};
  }
}
